(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/init-scripts.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/init-scripts.js');
"use strict";


var _svs$content$image_v = svs.content.image_v2.helpers,
  multiImageStyleElement = _svs$content$image_v.multiImageStyleElement,
  setLazyConfig = _svs$content$image_v.setLazyConfig;
var logger = new svs.core.log.Logger('image_v2:init-scripts');
var getUrlWithCorrectHost = Handlebars.helpers.getUrlWithCorrectHost;
var config = {
  options: svs.core.config.data.svsconfig
};

setLazyConfig();

var multiImageElements = document.querySelectorAll('[data-multi-image-id]');
multiImageElements.forEach(function (imageElement) {
  return multiImageStyleElement.setupForImageElement(imageElement);
});

function handleLoad(element) {
  var onloadCallbackPath = element.dataset.imageV2Onload;
  if (onloadCallbackPath) {
    try {
      var properties = onloadCallbackPath.split('.');
      var callbackFunction = properties.reduce(function (obj, property) {
        if (obj && obj[property]) {
          return obj[property];
        }
        logger.warn("Property ".concat(property, " not found in ").concat(onloadCallbackPath, "."));
        return null;
      }, self);
      if (typeof callbackFunction === 'function') {
        callbackFunction(element);
      } else {
        logger.warn("".concat(onloadCallbackPath, " is not a function."));
      }
    } catch (error) {
      logger.warn("Error executing onload callback: ".concat(error));
    }
  }
}

function handleError(element, currentSrc) {
  var fallbackImagePath = element.dataset.imageV2Fallbackimage;
  var fallbackImageUrl = getUrlWithCorrectHost(fallbackImagePath, config);
  if (fallbackImagePath) {
    var fallbackImage = element.cloneNode(true);
    fallbackImage.src = fallbackImageUrl;
    fallbackImage.setAttribute('is-fallback-image', 'true');
    element.parentElement.parentElement.appendChild(fallbackImage);
    element.parentElement.remove();
  } else {
    logger.warn('Error loading image:', currentSrc);
  }
}
document.addEventListener('DOMContentLoaded', function () {
  var imageElements = document.querySelectorAll('[data-image-v2-onload], [data-image-v2-fallbackimage]');
  imageElements.forEach(function (element) {
    var currentSrc = element.currentSrc;
    if (currentSrc) {
      var image = new Image();
      image.src = currentSrc;
      image.addEventListener('load', function () {
        handleLoad(element);
      });
      image.addEventListener('error', function () {
        handleError(element, currentSrc);
      });
    }
  });
});

 })(window);